import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { DataService } from 'src/app/data.service';
import { LanguageService } from 'src/app/language.service';
import { DialogService } from '../../services/dialog.service';
import { ParentalControlService } from '../../services/evergent/parental-control/parental-control.service';
import { NavigationLibraryService } from '../../services/navigation/navigation.service';
import { getErrorMessage } from '../../utils/evergentUtils';

@Component({
  selector: 'app-parental-pin',
  templateUrl: './parental-pin.component.html',
  styleUrls: ['./parental-pin.component.scss'],
})
export class ParentalPinComponent implements OnInit {
  pin: string[] = [];
  errorMessage: string = null;

  pinDisplayEndTime: number;
  pinDisplayStartTime: any;

  private destroy$ = new Subject<void>();

  constructor(
    private parentalControlService: ParentalControlService,
    private dataService: DataService,
    private readonly navService: NavigationLibraryService,
    private readonly dialogService: DialogService,
    private readonly languageService: LanguageService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((event: NavigationEnd) => {
        if (event.url.includes('/player/')) {
          this.dialogService.close();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onKeyPress(key: string) {
    if (this.pin.length < 4) {
      this.pin.push(key);
    }
    if (this.pin.length === 4) {
      this.focusPinInputAction();
    }
  }

  focusPinInputAction() {
    this.navService.focusContainer('actions', true, 0);
  }

  onBackspace() {
    if (this.pin.length > 0) {
      this.pin.pop();
      this.errorMessage = null;
    }
  }

  onPinSubmitted(pin: string) {
    if (!pin || pin.trim().length === 0) {
      this.errorMessage =
        this.languageService.getTranslatedText('parental_pin_empty');
      return;
    }
    this.parentalControlService
      .validateParentalControlPin(pin)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if (
          data.ValidateParentalControlPINResponseMessage.responseCode === '1'
        ) {
          this.pinDisplayEndTime = new Date().getTime();
          this.dataService.parentalDisplayDuration = this.pinDisplayStartTime
            ? this.pinDisplayEndTime - this.pinDisplayStartTime
            : 0;
          if (this.data.onSuccess) {
            this.data.onSuccess();
          }
          // The dialog will close automatically when the player route is loaded
        } else {
          /* this.errorMessage = getErrorMessage(
            data.ValidateParentalControlPINResponseMessage
          ); */
          this.errorMessage = 'global.error_empty_parental_pin';
          // this.clearOtp();
          // this.otpCounter = 0;
        }
      });
  }

  onPinCleared() {
    this.dialogService.close();
    this.pin = [];
    this.data?.onCancel?.();
  }

  onBackButtonClick() {
    this.onPinCleared();
  }

  disabled(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }
}
